import { IonIcon } from '@ionic/react'
import * as Sentry from '@sentry/react'
import { alertCircleOutline } from 'ionicons/icons'
import * as React from 'react'
import { AlertWrapper, Title, ReloadButton } from './styled'

type Props = {
  children: React.ReactNode
}

function ErrorFallback() {
  return (
    <AlertWrapper>
      <Title>
        <IonIcon
          icon={alertCircleOutline}
          style={{ width: '24px', height: '24px' }}
        />
        <div>На странице произошла ошибка</div>
      </Title>
      <div>
        Если после обновления страницы ошибка не проходит, обратитесь к
        администратору
      </div>
      <ReloadButton
        variant='contained'
        onClick={() => window.location.reload()}
      >
        Обновить
      </ReloadButton>
    </AlertWrapper>
  )
}

export function ErrorBoundary(props: Props) {
  const { children } = props
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  )
}
